import { Registry } from '../../../docs/registries/schema';
import logger from './logger';

const orderRegistriesByImportHierarchy = (registries: Registry[]) => {
  const clonedRegistries = [...registries];
  const orderedRegisties: Registry[] = [];
  const pushedNames: string[] = [];

  while (clonedRegistries.length) {
    // -------------------------------------------------------------------------
    // Pushes the name if the registry has no registry dependency or
    // all the registry dependencies has been already pushed
    // -------------------------------------------------------------------------
    for (const registry of clonedRegistries) {
      const hasNoRegistryDeps = !(registry.registryDependencies ?? []).length;
      const isAllRegistryDepsPushed = (
        registry.registryDependencies ?? []
      ).every((depName) => pushedNames.includes(depName));
      if (hasNoRegistryDeps || isAllRegistryDepsPushed) {
        orderedRegisties.push(registry);
        pushedNames.push(registry.name);
      }
    }
    // -------------------------------------------------------------------------
    // Deletes all registries that the name is pushed
    // -------------------------------------------------------------------------
    for (
      let currentIndex = clonedRegistries.length - 1;
      currentIndex >= 0;
      currentIndex -= 1
    ) {
      if (pushedNames.includes(clonedRegistries[currentIndex].name)) {
        clonedRegistries.splice(currentIndex, 1);
      }
    }
  }

  return orderedRegisties;
};

export default orderRegistriesByImportHierarchy;
